import React, { useState } from 'react';
import { LockIcon, CreditCardIcon, CheckCircle2Icon, BookOpenIcon, FileTextIcon, PenToolIcon, BarChartIcon, ZapIcon, MapIcon, ShieldCheckIcon } from 'lucide-react';
interface PricingSectionProps {
  compact?: boolean;
}
export function PricingSection({
  compact = false
}: PricingSectionProps) {
  const plans = [{
    id: 'basico',
    name: 'Kit Completo',
    subtitle: 'Lengua y Literatura',
    description: '6 Tomos + 3 Bonus',
    price: '$19.990',
    oldPrice: '$39.990',
    link: 'https://checkout.kitonline.shop/cart/47338873815278:1',
    emoji: '📚'
  }, {
    id: 'premium',
    name: 'Pack Premium',
    subtitle: 'Kit Completo + Maletín de Actividades de Lengua y Literatura',
    description: 'Todo el Kit + 50 actividades extra listas para el aula',
    price: '$29.990',
    oldPrice: '$59.990',
    link: 'https://checkout.kitonline.shop/cart/47547462222062:1',
    emoji: '👑'
  }];
  const [selectedPlan, setSelectedPlan] = useState('premium');
  const selectedLink = plans.find(p => p.id === selectedPlan)?.link || plans[1].link;
  const packDetails = ['Kit completo de contenidos 6 tomos', 'Pack literario irrenunciables 4 tomos', '3 bonus', 'Entrega inmediata por Drive (PDF)', 'Acceso de por vida — sin vencimiento', 'Garantía de satisfacción de 7 días'];
  return <section id={compact ? undefined : 'oferta'} className="py-8 sm:py-16 bg-transparent relative overflow-hidden border-t border-gray-800" data-id="element-167">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 bg-[#D4A843]/10 rounded-full blur-3xl pointer-events-none" data-id="element-168"></div>

      <div className="max-w-3xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-169">
        <h2 className="text-center text-2xl sm:text-4xl md:text-5xl font-black text-white mb-6 sm:mb-10 italic" data-id="element-170">
          Elegí tu Pack Completo
        </h2>

        {/* 2-Card Pricing */}
        <div className="grid grid-cols-2 gap-2.5 sm:gap-5 mb-5 sm:mb-8 items-stretch" data-id="element-171">
          {plans.map(plan => {
          const isSelected = selectedPlan === plan.id;
          const isPremium = plan.id === 'premium';
          return <button key={plan.id} type="button" onClick={() => setSelectedPlan(plan.id)} className={`relative rounded-xl sm:rounded-2xl overflow-visible flex flex-col text-left transition-all duration-300 cursor-pointer ${isSelected ? isPremium ? 'bg-[#1a1512] border-2 border-[#D4A843] shadow-[0_0_25px_rgba(212,168,67,0.3)] scale-[1.02]' : 'bg-[#121008] border-2 border-[#3b82f6] shadow-[0_0_25px_rgba(59,130,246,0.3)] scale-[1.02]' : 'bg-[#121008] border border-gray-700/50 opacity-70 hover:opacity-90'}`} data-id="element-172">
                {isPremium && <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20" data-id="element-173">
                    <span className="bg-[#D4A843] text-white text-[10px] sm:text-sm font-bold px-2.5 sm:px-4 py-0.5 sm:py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-174">
                      ⭐ Más elegido
                    </span>
                  </div>}
                <div className="absolute top-2 right-2 sm:top-3 sm:right-3 z-20" data-id="element-175">
                  <div className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? isPremium ? 'border-[#D4A843] bg-[#D4A843]' : 'border-[#3b82f6] bg-[#3b82f6]' : 'border-gray-600 bg-transparent'}`} data-id="element-176">
                    {isSelected && <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-177">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-178" />
                      </svg>}
                  </div>
                </div>
                <div className="p-3 sm:p-6 text-center flex flex-col items-center flex-1" data-id="element-179">
                  <span className="text-3xl sm:text-5xl mb-1.5 sm:mb-3" data-id="element-180">
                    {plan.emoji}
                  </span>
                  <h3 className="text-base sm:text-2xl font-black text-white mb-0.5 sm:mb-1" data-id="element-181">
                    {plan.name}
                  </h3>
                  <p className="text-gray-400 text-[9px] sm:text-sm mb-3 sm:mb-5 leading-tight px-1" data-id="element-182">
                    {plan.subtitle}
                  </p>
                  <div className="mt-auto" data-id="element-183">
                    <span className="text-3xl sm:text-6xl font-black block leading-none text-white" data-id="element-184">
                      {plan.price}
                    </span>
                    <span className="text-gray-500 text-sm sm:text-xl line-through decoration-red-500 decoration-2 mt-0.5 block" data-id="element-185">
                      {plan.oldPrice}
                    </span>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Area */}
        <div className="text-center mb-5 sm:mb-8" data-id="element-186">
          {/* Bullet Pills */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-4" data-id="element-187">
            <div className="flex items-center bg-[#121008] px-3 py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm" data-id="element-188">
              <FileTextIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#E8C547] mr-1.5" data-id="element-189" />
              <span className="text-[11px] sm:text-xs font-bold text-gray-200" data-id="element-190">
                100% PDF
              </span>
            </div>
            <div className="flex items-center bg-[#121008] px-3 py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm" data-id="element-191">
              <ZapIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#E8C547] mr-1.5" data-id="element-192" />
              <span className="text-[11px] sm:text-xs font-bold text-gray-200" data-id="element-193">
                Acceso inmediato
              </span>
            </div>
            <div className="flex items-center bg-[#121008] px-3 py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm" data-id="element-194">
              <BookOpenIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#E8C547] mr-1.5" data-id="element-195" />
              <span className="text-[11px] sm:text-xs font-bold text-gray-200" data-id="element-196">
                Secundaria
              </span>
            </div>
            <div className="flex items-center bg-[#121008] px-3 py-1.5 rounded-full border border-[#D4A843]/30 shadow-sm" data-id="element-197">
              <MapIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#E8C547] mr-1.5" data-id="element-198" />
              <span className="text-[11px] sm:text-xs font-bold text-gray-200" data-id="element-199">
                Currículo argentino
              </span>
            </div>
          </div>

          <a href={selectedLink} className="inline-block w-full max-w-md bg-gradient-to-b from-[#D4A843] to-[#9A7B24] text-white font-black text-base sm:text-2xl py-3 sm:py-4 px-6 rounded-lg border-2 border-[#E8C547]/40 shadow-[0_0_20px_rgba(212,168,67,0.35)] hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] hover:scale-[1.02] active:scale-95 transition-all duration-200 italic animate-subtle-bounce" data-id="element-200">
            Sí, quiero mi pack →
          </a>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5 mt-4 text-gray-400 text-[10px] sm:text-xs font-medium" data-id="element-201">
            <div className="flex items-center" data-id="element-202">
              <ShieldCheckIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#3b82f6] mr-1.5" data-id="element-203" />
              <span data-id="element-204">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center" data-id="element-205">
              <LockIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#f59e0b] mr-1.5" data-id="element-206" />
              <span data-id="element-207">Pago 100% seguro</span>
            </div>
            <div className="flex items-center" data-id="element-208">
              <CreditCardIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#3b82f6] mr-1.5" data-id="element-209" />
              <span data-id="element-210">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </div>

        {/* Only show details when NOT compact */}
        {!compact && <>
            {/* Pack details box */}
            <div className="bg-[#1a1512] border border-[#D4A843]/30 rounded-xl p-3 sm:p-5 max-w-md mx-auto" data-id="element-211">
              <p className="text-white font-bold text-sm sm:text-base mb-2 sm:mb-3 text-center uppercase tracking-wide" data-id="element-212">
                👑 Pack Premium incluye:
              </p>
              <ul className="space-y-1.5 sm:space-y-2.5" data-id="element-213">
                {packDetails.map((item, i) => <li key={i} className="flex items-start text-gray-300 text-xs sm:text-base font-medium" data-id="element-214">
                    <span className="text-[#D4A843] mr-2 flex-shrink-0 text-base sm:text-lg" data-id="element-215">
                      ✅
                    </span>
                    <span data-id="element-216">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Premium Bloques Detail */}
            <div className="mt-8 sm:mt-12 bg-[#1a1512] border border-[#D4A843]/20 rounded-xl p-3 sm:p-6 max-w-lg mx-auto" data-id="element-217">
              <div className="text-center mb-4 sm:mb-6" data-id="element-218">
                <span className="bg-[#D4A843]/10 text-[#E8C547] border border-[#D4A843]/30 px-3 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2 inline-block" data-id="element-219">
                  Contenido Detallado
                </span>
                <h3 className="text-white font-black text-base sm:text-xl uppercase tracking-wide" data-id="element-220">
                  👑 Índice del Pack Premium
                </h3>
              </div>
              <div className="space-y-3 sm:space-y-4" data-id="element-221">
                <div className="bg-[#121008] p-3 sm:p-4 rounded-lg border border-[#D4A843]/20" data-id="element-222">
                  <div className="flex items-center gap-2 mb-1" data-id="element-223">
                    <BookOpenIcon className="text-[#E8C547] w-4 h-4" data-id="element-224" />
                    <h4 className="text-white font-bold text-xs sm:text-sm" data-id="element-225">
                      BLOQUE 1 — BIBLIOTECA LITERARIA
                    </h4>
                  </div>
                  <p className="text-[#E8C547] text-[10px] sm:text-xs font-bold mb-1" data-id="element-226">
                    📚 12–15 textos · 60–80 págs
                  </p>
                  <p className="text-gray-400 text-[10px] sm:text-xs leading-relaxed" data-id="element-227">
                    Textos de Quiroga, Cortázar, Borges, García Márquez + otros.
                    Cada texto: contexto, comprensión, análisis, producción
                    escrita, evaluación.
                  </p>
                </div>
                <div className="bg-[#121008] p-3 sm:p-4 rounded-lg border border-[#D4A843]/20" data-id="element-228">
                  <div className="flex items-center gap-2 mb-1" data-id="element-229">
                    <FileTextIcon className="text-[#E8C547] w-4 h-4" data-id="element-230" />
                    <h4 className="text-white font-bold text-xs sm:text-sm" data-id="element-231">
                      BLOQUE 2 — SECUENCIAS DIDÁCTICAS
                    </h4>
                  </div>
                  <p className="text-[#E8C547] text-[10px] sm:text-xs font-bold mb-1" data-id="element-232">
                    📘 12 clases completas · 60–80 págs
                  </p>
                  <p className="text-gray-400 text-[10px] sm:text-xs leading-relaxed" data-id="element-233">
                    Cada clase: objetivo, actividad de inicio, desarrollo paso a
                    paso, actividades prácticas, cierre, evaluación.
                  </p>
                </div>
                <div className="bg-[#121008] p-3 sm:p-4 rounded-lg border border-[#D4A843]/20" data-id="element-234">
                  <div className="flex items-center gap-2 mb-1" data-id="element-235">
                    <PenToolIcon className="text-[#E8C547] w-4 h-4" data-id="element-236" />
                    <h4 className="text-white font-bold text-xs sm:text-sm" data-id="element-237">
                      BLOQUE 3 — PRODUCCIÓN AVANZADA
                    </h4>
                  </div>
                  <p className="text-[#E8C547] text-[10px] sm:text-xs font-bold mb-1" data-id="element-238">
                    ✍️ Escritura y análisis · 60–80 págs
                  </p>
                  <p className="text-gray-400 text-[10px] sm:text-xs leading-relaxed" data-id="element-239">
                    Ensayo argumentativo, escritura académica, análisis crítico,
                    ejercicios guiados, producciones y evaluaciones.
                  </p>
                </div>
                <div className="bg-[#121008] p-3 sm:p-4 rounded-lg border border-[#D4A843]/20" data-id="element-240">
                  <div className="flex items-center gap-2 mb-1" data-id="element-241">
                    <BarChartIcon className="text-[#E8C547] w-4 h-4" data-id="element-242" />
                    <h4 className="text-white font-bold text-xs sm:text-sm" data-id="element-243">
                      BLOQUE 4 — SISTEMA PRO EVALUACIÓN
                    </h4>
                  </div>
                  <p className="text-[#E8C547] text-[10px] sm:text-xs font-bold mb-1" data-id="element-244">
                    📊 Evaluación completa · 60–80 págs
                  </p>
                  <p className="text-gray-400 text-[10px] sm:text-xs leading-relaxed" data-id="element-245">
                    Rúbricas por competencias, evaluaciones listas,
                    recuperatorios, plantillas de corrección, instrumentos
                    prácticos.
                  </p>
                </div>
              </div>

              {/* Pack Literario */}
              <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-700/50" data-id="element-246">
                <div className="bg-[#1a1512] border-2 border-[#D4A843]/40 rounded-xl p-4 sm:p-6 text-center shadow-[0_0_20px_rgba(212,168,67,0.1)]" data-id="element-247">
                  <span className="text-3xl sm:text-4xl mb-2 block" data-id="element-248">📖</span>
                  <h4 className="text-lg sm:text-2xl font-black text-white mb-1" data-id="element-249">
                    Pack Literario Irrenunciables
                  </h4>
                  <p className="text-[#E8C547] font-bold text-xs sm:text-sm mb-3" data-id="element-250">
                    4 Tomos + 3 Bonus
                  </p>
                  <div className="mb-4" data-id="element-251">
                    <span className="text-3xl sm:text-5xl font-black text-white" data-id="element-252">
                      $17.990
                    </span>
                    <span className="text-gray-500 text-sm sm:text-lg line-through decoration-red-500 decoration-2 ml-2" data-id="element-253">
                      $35.990
                    </span>
                  </div>
                  <a href="https://checkout.kitonline.shop/cart/47801773719790:1" className="inline-block w-full max-w-xs bg-gradient-to-b from-[#D4A843] to-[#9A7B24] text-white font-black text-sm sm:text-lg py-2.5 sm:py-3 px-6 rounded-lg border-2 border-[#E8C547]/40 shadow-[0_0_15px_rgba(212,168,67,0.3)] hover:shadow-[0_0_25px_rgba(212,168,67,0.5)] hover:scale-[1.02] active:scale-95 transition-all duration-200 animate-subtle-bounce" data-id="element-254">
                    Quiero este pack →
                  </a>
                </div>
              </div>
            </div>
          </>}
      </div>
    </section>;
}